import { http } from '@/utils/http';
import { CompositionHttp } from '@/utils/CompositionHttp';
import qs from 'qs';

const baseUrl = 'vote/2020project/2020solicitationactivities/controller.php?enews=';
const api = process.env.VUE_APP_CQCB_API;
interface IVoteListOption {
  search?: string | number;
  page?: number;
}

export const initPublish = () => {
  return http.get(`${baseUrl}init-publish`);
};
// 学校搜索
// export const schoolSearch = ({ search, page }: IVoteListOption) => {
//   return http.get(`${baseUrl}school-search`, {
//     params: { search, page },
//   });
// };
// 验证作文用户
export function getUserType() {
  return CompositionHttp.get(`${api}/api/composition/user/indexSetting`);
}

// 最新投稿
export const typeListAll = () => {
  return http.get(`${baseUrl}index-list`);
};

// 最新分类列表
export const typeList = (type?: any, page?: number) => {
  return http.get(`${baseUrl}type-list`, {
    params: { type, page },
  });
};
// 点赞排行
export const voteList = ({ page, search }: IVoteListOption) => {
  return http.get(`${baseUrl}vote-list`, {
    params: { page, search },
  });
};

// 总助力
export const userHelper = () => {
  return http.get(`${baseUrl}user-helper`);
};

// 规则
export const getRules = () => {
  return http.get(`${baseUrl}rules`);
};

// 获取作文详情页面
export const detail = (id: any) => {
  return http.get(`${baseUrl}detail&id=` + id);
};

// 用户个人列表
export const userList = (page: number) => {
  return http.get(`${baseUrl}user-list`, {
    params: { page },
  });
};

// 个人列表删除接口
export const userDel = (id: any) => {
  return http.get(`${baseUrl}user-del&id=` + id);
};

// 个人发布接口
export const init = () => {
  return http.get(`${baseUrl}init`);
};
